import { MessageSquare, Mail, MapPin, Clock } from "lucide-react";
import { PHONE, PHONE_TEL, PHONE_HELP, PHONE_HELP_TEL, BRAND } from "@/lib/api";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#050F26] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <div className="h-9 w-9 rounded-md bg-[#0B1B3D] border border-[#C5A059]/30 flex items-center justify-center">
              <span className="font-display text-[#C5A059] text-xl leading-none">C</span>
            </div>
            <div className="font-display text-xl">{BRAND}</div>
          </div>
          <p className="text-white/60 text-sm leading-relaxed max-w-md">
            We help homeowners across all 50 states stop foreclosure, sell on
            their terms, and recover surplus funds they're legally owed.
            Confidential, free consultations — always.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-[#C5A059] mb-4">Services</div>
          <ul className="space-y-2 text-sm text-white/75">
            <li><a href="#services" className="hover:text-[#C5A059]">All Services</a></li>
            <li><a href="#pre-foreclosure" className="hover:text-[#C5A059]">Pre-Foreclosure Help</a></li>
            <li><a href="#surplus-funds" className="hover:text-[#C5A059]">Surplus Funds Recovery</a></li>
            <li><a href="#sell-fast" className="hover:text-[#C5A059]">Sell Your House Fast</a></li>
            <li><a href="#agents" className="hover:text-[#C5A059]">Partner Programs</a></li>
            <li><a href="#cash-buyers" className="hover:text-[#C5A059]">Cash Buyer List</a></li>
            <li><a href="#wholesalers" className="hover:text-[#C5A059]">Wholesaler Desk</a></li>
            <li><a href="#veterans" className="hover:text-[#C5A059]">Veteran Housing Program</a></li>
            <li><a href="#faq" className="hover:text-[#C5A059]">FAQ</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.22em] text-[#C5A059] mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-white/75">
            <li className="flex items-start gap-3">
              <MessageSquare className="h-4 w-4 mt-0.5 text-[#C5A059]" />
              <div>
                <a href={`sms:${PHONE_TEL}`} className="hover:text-white block" data-testid="footer-phone">
                  {PHONE}
                </a>
                <span className="text-[11px] uppercase tracking-[0.14em] text-white/40">Text us — main line</span>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="h-4 w-4 mt-0.5 text-[#C5A059]" />
              <div>
                <a href={`tel:${PHONE_HELP_TEL}`} className="hover:text-white block" data-testid="footer-help-phone">
                  {PHONE_HELP}
                </a>
                <span className="text-[11px] uppercase tracking-[0.14em] text-white/40">24/7 help — call anytime</span>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="h-4 w-4 mt-0.5 text-[#C5A059]" />
              <a href="mailto:clearpathhomereliefservices@gmail.com" className="hover:text-white">
                clearpathhomereliefservices@gmail.com
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-[#C5A059]" />
              <span>Serving homeowners nationwide — all 50 states.</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row gap-4 items-center justify-between text-xs text-white/50">
          <div>© {year} {BRAND}. All rights reserved.</div>
          <div className="max-w-3xl text-center md:text-right leading-relaxed">
            Clear Path Home Relief Services is not a law firm, lender, or government agency. Information on this site is educational.
            Always consult a licensed attorney regarding your specific legal rights.
          </div>
        </div>
      </div>
    </footer>
  );
}
